import { number, object, string } from 'yup';

import { ConverterT5G } from '@utils/frequencyConverters/nrarfcnConverter';
import { FREQ_MAX, FREQ_MIN } from '@utils/frequencyConverters/T5GConverter';

import { TValueOfStringRecord } from '@interfaces/common/genericWithModifying';
import { TSelectOptionType } from '@components/common/Select/Select.types';

import { getMinMaxDigitalValue, mandatoryErrMessage, validationErrMessages } from '@constants/validationConstants';

export const EEditFrequencyBandLabels = {
	nrArfcn: 'NR_ARFCN',
	nrBand: 'NR_BAND',
	frequency: 'Frequency',
} as const;

export const EEditFrequencyBandModalFields = {
	nrArfcn: 'nrArfcn',
	nrBand: 'nrBand',
	frequency: 'frequency',
} as const;

export type TEditFrequencyBandLabels = TValueOfStringRecord<typeof EEditFrequencyBandLabels>
export type TEditFrequencyBandModalFields = TValueOfStringRecord<typeof EEditFrequencyBandModalFields>

export const schema = object().shape({
	[EEditFrequencyBandModalFields.nrArfcn]: string()
		.test('min-max', validationErrMessages.configParameterInvalidValue, (value) => {
			const numValue = Number(value);

			return !isNaN(numValue) && numValue >= ConverterT5G.NRARFCN_MIN && numValue <= ConverterT5G.NRARFCN_MAX;
		})
		.nullable()
		.transform((value) => (isNaN(value) ? undefined : value))
		.required(mandatoryErrMessage(EEditFrequencyBandLabels.nrArfcn)),
	[EEditFrequencyBandModalFields.frequency]: number()
		.min(ConverterT5G.FREQ_MIN, getMinMaxDigitalValue({
			name: EEditFrequencyBandLabels.frequency,
			min: FREQ_MIN,
			max: FREQ_MAX,
		}))
		.max(ConverterT5G.FREQ_MAX, getMinMaxDigitalValue({
			name: EEditFrequencyBandLabels.frequency,
			min: ConverterT5G.FREQ_MIN,
			max: ConverterT5G.FREQ_MAX,
		}))
		.typeError('Amount must be a number')
		.transform((value) => (isNaN(value) ? undefined : value))
		.nullable()
		.required(mandatoryErrMessage(EEditFrequencyBandLabels.frequency)),
	[EEditFrequencyBandModalFields.nrBand]: object()
		.nullable()
		.required(mandatoryErrMessage(EEditFrequencyBandLabels.nrBand)),
});

export interface IEditFrequencyBand {
	[EEditFrequencyBandModalFields.nrArfcn]?: string | number | null;
	[EEditFrequencyBandModalFields.frequency]?: string | number | null;
	[EEditFrequencyBandModalFields.nrBand]?: TSelectOptionType<string> | null;
}
